import { render, staticRenderFns } from "./AppDashboard.vue?vue&type=template&id=3c03d3dc&scoped=true"
import script from "./AppDashboard.vue?vue&type=script&lang=js"
export * from "./AppDashboard.vue?vue&type=script&lang=js"
import style0 from "./AppDashboard.vue?vue&type=style&index=0&id=3c03d3dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c03d3dc",
  null
  
)

export default component.exports